module.exports = __webpack_public_path__ + "img/theme4.1cde22c5.png";